import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormattedMessage} from 'react-intl';

import {IStore} from 'redux/interface';
import {exerciseAsyncActions, getExerciseDialogue, getTranslations} from 'redux/pageAsyncActions';
import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {BotType} from 'utils/hooks/use-chat-bot/interfaces';
import {Pages, TranslationKeys} from 'utils/constants/routeConstants';

import BotChat from 'components/bot-chat';

import {closeArticle} from 'redux/content/actions';
import XpeditionIcon from 'assets/image/menu-auth/xpedition.png';
import {Link, useParams} from 'react-router-dom';

import './styles.scss';
import {BotMode} from '@wholesalechange/chatcomponent';

export const ExerciseChat: React.FunctionComponent = () => {
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const {
    exerciseDialogue
  } = useSelector((state: IStore) => state.exercise);
  const {
    settings
  } = useSelector((state: IStore) => state.auth);
  const dispatch = useDispatch();
  const {dialogueId} = useParams();

  useEffect(() => {
    dispatch(closeArticle());
  }, []);

  useEffect(() => {
    if (dialogueId) {
      dispatch(exerciseAsyncActions[getExerciseDialogue](Number(dialogueId)));
    }
  }, [dialogueId]);

  const translationKey = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Exercises.toLowerCase());

    return page?.translationKey || TranslationKeys.Exercise;
  }, [settings]);

  useGetTranslations({translationKey});

  const title = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Exercises.toLowerCase());

    return page?.title || Pages.Exercises;
  }, [settings]);

  function renderBreadcrumbs() {
    return <div className="breadcrumbs">
      <Link className="breadcrumbs__previous" to="/exercise">
        <FormattedMessage
          id={'gritx.exercise.breadcrumb.previous'}
          defaultMessage="Exercise"
        />
      </Link> {exerciseDialogue && <span className="exercise-chat__title-dialogue-name"> - {exerciseDialogue.dialogName}</span>}
    </div>;
  }

  return <div className="exercise-chat">
    {
      !loading.includes(getTranslations) && exerciseDialogue && <>
        <h1 className="exercise-chat__title">
          <img src={XpeditionIcon} alt="" className="exercise-chat__icon"/>
          {renderBreadcrumbs()}
        </h1>
        <BotChat chatType={BotType.Xpedition} chatMode={BotMode.NoHistory} dialogueId={exerciseDialogue.dialogId}
          title={exerciseDialogue.dialogName}
          tabsEnabled={settings?.chatSettings?.tabsEnabled || false}/>
      </>
    }
  </div>;
};
